import store from '../../src/store'; 

export const getPermissionForComponent = (componentName, userGroup) => {
  const groupPermissions = store.getState().AppState.permissionGroup;


  // const user = store.getState().AppState.user;

  // // Get the permissions for the specific user group
  // const groupPermissions = permissionGroups[userGroup];

  if (groupPermissions && groupPermissions[componentName]) {

    const { read, write } = groupPermissions[componentName];


    // if ((read && write) || user?.epikEngineering) {
    if (read && write) {
      return 'both';
    } else if (write) {
      return 'write';
    } else if (read) {
      return 'read';
    }
  }

  return false; // No access
};
// export const canView = (access) =>
//   access === 'read' || access === 'write' || access === 'both';

// export const canWrite = (access) =>
//   access === 'write' || access === 'both';

export const normalizeAccess = (access, permKey = "") => {
  const result = (() => {
    if (!access) return { read: false, write: false };
    if (access === "read") return { read: true, write: false };
    if (access === "both") return { read: true, write: true };
    if (access === "write") return { read: false, write: false };
    return { read: false, write: false };
  })();
  return result;
};

export const canView = (access, permKey) => normalizeAccess(access, permKey).read;
export const canWrite = (access, permKey) => normalizeAccess(access, permKey).write;